import { useState } from "react";

// Ключ варианта A/B-теста в sessionStorage.
const AB_KEY = "ab_variant";

/**
 * Определяет вариант A/B-теста.
 * - путь /b или /c -> соответствующий вариант, сохраняется на сессию
 * - ?ab=b / ?ab=c  -> то же (запасной вариант ссылки)
 * - ?ab=a  -> принудительно вариант "a" (откат к текущему)
 * - без признаков -> берётся ранее сохранённый вариант или "a" по умолчанию
 *
 * Трафик на варианты разводится снаружи (реклама/ссылка вида /b, /c),
 * авто-сплита нет — это сознательное решение для этого теста.
 */
const VARIANTS = ["a", "b", "c"];

export function getAbVariant() {
  if (typeof window === "undefined") return "a";
  try {
    const { pathname, search } = window.location;
    // Чистый путь /b или /c -> соответствующий вариант
    const pathVariant = pathname.replace(/\/$/, "").slice(1); // "/b" -> "b"
    if (pathVariant === "b" || pathVariant === "c") {
      sessionStorage.setItem(AB_KEY, pathVariant);
      return pathVariant;
    }
    const param = new URLSearchParams(search).get("ab");
    if (VARIANTS.includes(param)) {
      sessionStorage.setItem(AB_KEY, param);
      return param;
    }
    const stored = sessionStorage.getItem(AB_KEY);
    if (VARIANTS.includes(stored)) return stored;
  } catch {
    // sessionStorage может быть недоступен (приватный режим) — тихо откатываемся на "a"
  }
  return "a";
}

/**
 * Стабильный на время сессии вариант. Вычисляется один раз при первом рендере,
 * чтобы не было мерцания между A и B.
 */
export function useAbVariant() {
  const [variant] = useState(getAbVariant);
  return variant;
}
